import React from 'react';
import { Col, Container, Row } from 'reactstrap';

const StaticFooter = () => {
    return (
        <footer className="footer bg-dark w-100">
            <Container fluid>
                <Row>
                    <Col sm={6}>{new Date().getFullYear()} © GGH.</Col>
                    <Col sm={6}></Col>
                </Row>
            </Container>
        </footer>
    );
};

export default StaticFooter;
